/** @format */
import { FAN_ANGLE_STEP_DEGREES } from './config/constants';

/**
 * How far a card is tilted out of the hand, in degrees.
 *
 * The hand is centred on the middle card, so the tilt runs symmetrically from
 * negative on the left of the hand to positive on the right, and a hand of one
 * card sits upright.
 */
export function getFanCardAngle(index: number, count: number): number {
    const middleIndex = (count - 1) / 2;
    return (index - middleIndex) * FAN_ANGLE_STEP_DEGREES;
}
